import { useAuth0 } from '@auth0/auth0-react';
import { useAuthSessionCookie } from './useAuthSessionCookie';

export const useLogout = () => {
  const { logout } = useAuth0();
  const { isSessionCookiePresent, removeSessionCookie } =
    useAuthSessionCookie();

  return async () => {
    if (isSessionCookiePresent) {
      removeSessionCookie();
      sessionStorage.clear();
      localStorage.removeItem('authResult');
      document.location.href = '/';
      logout({ logoutParams: { returnTo: window.location.origin } });
    } else {
      sessionStorage.clear();
      localStorage.removeItem('authResult');
      logout({ logoutParams: { returnTo: window.location.origin } });
    }
  };
};
